import { LocalStorageService, Utilities, AlertService } from 's2s-app-service';
import LoggingService from 's2s-logging-service';

const objectMerge = require('object-merge');

const url = require('url');

// set version to what is set in package.json
const appVersion = require('../../package.json').version;

const settings = (state, action)=>{
  if (!state){ // undefined
    const languages=[
               {id: 'en', label: 'English'},
               {id: 'it', label: 'Italiano'},
               {id: 'fr', label: 'Français'},
               {id: 'de', label: 'Deutsch'},
               {id: 'pt', label: 'Português'},
               {id: 'pl', label: 'Polski'},
               {id: 'zh', label: '中國'},
               {id: 'ru', label: 'Pусский'},
               {id: 'sv', label: 'Svenska'},
               {id: 'da', label: 'Dansk'},
               {id: 'es', label: 'Español'},
               {id: 'id', label: 'Indonesia'}
   ];

   const ringTones = [
     {'id': 0, 'source':'../assets/sounds/bell_ring2.wav', 'label': 'Bell'},
     {'id': 1, 'source':'../assets/sounds/warble.wav', 'label': 'Warble'}
   ];
   const themes = ['Default','Light', 'Dark'];

    let returnSettings = {appVersion, 'alwaysontop': true, 'advancedLogging': false, "selectedTheme": themes[0], "themes": themes, "ringTones": ringTones, "selectedRingTone": ringTones[0].source, "selectedLanguage": languages[0], "languages": languages };

    const lsSettings = LocalStorageService.getData('settings');

    if (lsSettings.data && lsSettings.data.hasOwnProperty('alwaysontop') ){
      //LoggingService.getInstance().debug('have lsSettings', lsSettings.data);
      lsSettings.data.languages.sort((a,b)=>{
        return a.label.localeCompare(b.label);
      });

      returnSettings = lsSettings.data;
      returnSettings.localStorageSelectedAudio = returnSettings.selectedAudio;
      returnSettings.localStorageSelectedSpeaker = returnSettings.selectedSpeaker;
      // removed selected because might not be valid;
      returnSettings.selectedAudio ={};
      returnSettings.selectedSpeaker ={};
      returnSettings.appVersion = appVersion;

      //LoggingService.getInstance().debug('have lsSettings', lsSettings.data);
    } else {
      // save default to settings --- safe guarding it
      LocalStorageService.setData('settings', returnSettings);
    }

    // clear the restarting flag from LocalStorageService
    //LocalStorageService.setData('restarting', false);

    LoggingService.getInstance().setLogLevel(returnSettings.advancedLogging ? 'debug' : 'info');
    // set it via application also
    if (typeof setLogLevel == 'function'){
      setLogLevel(returnSettings.advancedLogging ? 'debug' : 'info');
    } else if (typeof(window['setLogLevel']) == 'function') {
      window.setLogLevel(returnSettings.advancedLogging ? 'debug' : 'info');
    }
    //LoggingService.getInstance().debug('RRRR: ', returnSettings);
    return returnSettings;
  }

  switch (action.type) {
    case 'AUTH_DATA':
          LoggingService.getInstance().debug('SETTINGS REDUCER --- AUTH_DATA', action.payload);

          const softphoneExtensions = action.payload.extensions.filter((e)=>{
            return e.phone === 129;
          });
          let selectedExtension;
          if (!state.selectedExtension){
            selectedExtension = softphoneExtensions[0].extension;
          } else {
            selectedExtension = state.selectedExtension;
          }

          return { ...state, "extensions": softphoneExtensions, "selectedExtension": selectedExtension };
          //return state
    case "MEDIA":
      {
        LoggingService.getInstance().debug('SETTINGS REDUCER --- MEDIA', state, action.payload);
        const myMedia = { ...state };
        //const myMedia = objectMerge(state, action.payload) ;
        Object.keys(action.payload).map((k, i )=>{
          LoggingService.getInstance().debug('kkkkkk', k, action.payload[k])
          // validate we have a label if we do not set it to no label i
          myMedia[k] = action.payload[k];

          LoggingService.getInstance().debug('>>>>>', k, action.payload[k], myMedia[k]);
        });
        if (myMedia.audioDevices.length < 1){
          setTimeout(function(){
            LoggingService.getInstance().debug('missing microphone')
            AlertService.getInstance().createErrorAlert({alertHeadingText: Utilities.getInstance().getIntlMessage('ALERT-MIC', 'Missing Microphone'), isPersistent: true});
          }, 3000);
          return;
        }

        if (myMedia.speakerDevices.length < 1){
          setTimeout(function(){
            LoggingService.getInstance().debug('missing speaker')
            AlertService.getInstance().createErrorAlert({alertHeadingText: Utilities.getInstance().getIntlMessage('ALERT-SPEAKER', 'Missing Speaker'), isPersistent: true});
          }, 3000);
          return;
        }
        LoggingService.getInstance().debug('>>>>>', myMedia);
        // check for defaults
        //if (!myMedia.hasOwnProperty('selectedSpeaker')) {
        if (myMedia.localStorageSelectedSpeaker) {
          if (myMedia.speakerDevices.filter((device)=>{return device.label == myMedia.localStorageSelectedSpeaker.label;}).length == 0) {
            LoggingService.getInstance().debug('Speaker not there anymore!!!!!!!', myMedia.selectedSpeaker.label )
            myMedia.selectedSpeaker = { ...myMedia.speakerDevices[0]};
          } else {
            // set it to what it was since I found it
            myMedia.selectedSpeaker = myMedia.localStorageSelectedSpeaker;

          }
          // remove it localstorage stuff
          delete myMedia.localStorageSelectedSpeaker;
        } else {
          // normal run through
          // if the selectedSpeaker is not in the speakerDevices array, set to the first one in array
          if (myMedia.speakerDevices.filter((device)=>{
                  if (myMedia.selectedSpeaker && myMedia.selectedSpeaker.hasOwnProperty('label')){
                    return device.label == myMedia.selectedSpeaker.label;
                  } else {
                    return false;
                  }
              }).length == 0) {
            myMedia.selectedSpeaker = { ...myMedia.speakerDevices[0]};
          }
        }

        if (myMedia.localStorageSelectedAudio) {
          if (myMedia.audioDevices.filter((device)=>{
                return device.label == myMedia.localStorageSelectedAudio.label;
              }).length == 0) {
            myMedia.selectedAudio = { ...myMedia.audioDevices[0] };
          } else {
            // set it to what it was since I found it
            myMedia.selectedAudio = myMedia.localStorageSelectedAudio;
          }
          // remove it localstorage stuff
          delete myMedia.localStorageSelectedAudio;
        } else {
          // if the selectedAudio is not in the audioDevices array, set to the first one in array
          if (myMedia.audioDevices.filter((device)=>{
              if (myMedia.selectedAudio && myMedia.selectedAudio.hasOwnProperty('label')){
                return device.label == myMedia.selectedAudio.label;
              } else {
                return false;
              }

              }).length == 0) {
            myMedia.selectedAudio = { ...myMedia.audioDevices[0]};
          }
        }

        return myMedia;
      }
    case 'SETTINGS_UPDATE':
    {
      LoggingService.getInstance().debug('SETTINGS REDUCER --- SETTINGS_UPDATE', action.payload);
      const settingsUpdate = {};
      switch(action.payload.key){
        case 'extension':
          LoggingService.getInstance().debug('SETTINGS_UPDATE --- KEY', action.payload.key);
          settingsUpdate['selectedExtension'] = action.payload.value;
          break;
        case 'ringtone':
          LoggingService.getInstance().debug('SETTINGS_UPDATE --- KEY', action.payload.key);
          if (state.hasOwnProperty("ringTones")){
            settingsUpdate['selectedRingTone'] = state.ringTones.filter((r)=>{return r.label == action.payload.value})[0].source;
          }
          break;
        case 'defaultdevice':
          LoggingService.getInstance().debug('SETTINGS_UPDATE --- KEY', action.payload.key);
          if (state.hasOwnProperty("audioDevices")){
            settingsUpdate['selectedAudio'] = state.audioDevices.filter((a)=>{return a.label == action.payload.value})[0];
          }
          break;
        case 'ringdevice':
          LoggingService.getInstance().debug('SETTINGS_UPDATE --- KEY', action.payload.key);
          if (state.hasOwnProperty("speakerDevices")){
            settingsUpdate['selectedSpeaker'] = state.speakerDevices.filter((a)=>{return a.label == action.payload.value})[0];
          }
          break;
        case 'theme':
          LoggingService.getInstance().debug('SETTINGS_UPDATE --- KEY', action.payload.key);
          settingsUpdate['selectedTheme'] = action.payload.value;
          break;
        case 'language':
          LoggingService.getInstance().debug('SETTINGS_UPDATE --- KEY', action.payload.key);
          settingsUpdate['selectedLanguage'] = state.languages.filter((l)=>{return l.label == action.payload.value})[0];
          break;
        case 'alwaysontop':
          LoggingService.getInstance().debug('SETTINGS_UPDATE --- KEY', action.payload.key);
          settingsUpdate['alwaysontop'] = action.payload.value;
          break;
        case 'advancedLogging':
          settingsUpdate['advancedLogging'] = action.payload.value;
          LoggingService.getInstance().setLogLevel(settingsUpdate['advancedLogging'] ? 'debug' : 'info');
          break;
        case 'importContacts':
          LoggingService.getInstance().debug('SETTINGS_UPDATE --- KEY', action.payload.key);
          break;

        default:
          LoggingService.getInstance().error('settings update key not handled: ', action.payload.key, action.payload.value);
      }

      const returnSettings = { ...state, ...settingsUpdate};

      LocalStorageService.setData('settings', returnSettings);

      return returnSettings;
    }

    default:
     return state;
  }
};

export { settings };



// WEBPACK FOOTER //
// ./src/reducers/settings-reducers.js